import clsx from 'clsx'
import React from 'react'
import Loader from "react-loader-spinner";

const Button = ({ loading, className, disabled, children, kind = 'primary', ...rest }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      {...rest}
      className={clsx(`w-72 h-12 mx-auto capitalize ${kind === 'primary' ? 'text-white' : 'text-white'} ${kind === 'primary' ? 'bg-pallet-3' : 'bg-black'} focus:ring-0 rounded-full text-lg px-5 py-2.5 me-2 mb-2 focus:outline-none font-bold`, disabled && 'opacity-60', !disabled && `${kind === 'primary' ? 'hover:bg-pallet-8' : 'hover:bg-pallet-9'}`, className)}
    >
      {loading ? (
        <Loader
          type="Oval"
          visible={true}
          color="#0083ff"
          width={24}
          height={24}
          className="flex flex-1 justify-center items-center"
        />
      ) : children}
    </button>
  )
}

export default Button
